export default __webpack_public_path__ + "static/media/data_paso(1).e8653488.png";